import { snapshot } from 'valtio'
import type React from 'react'
import { toast } from 'react-toastify'
import { buildAxiosInstance } from '../utils/apiUtils'
import { transactionProxy } from '../proxies/transactionProxy'
import { virtualTerminalProxy } from '../../routes/app/virtual-terminal/index/virtualTerminalProxy'
export async function executeResendEmailForTransaction (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>): Promise<void> {
  (e as React.FormEvent)?.preventDefault()

  transactionProxy.apiCall.loading = true
  transactionProxy.apiCall.error = null
  const { transaction } = snapshot(transactionProxy)
  try {
    const response = await buildAxiosInstance().post('/api/transactions/send_receipt_email',
      {
        transactionId: transaction?.id
      }
    )
    if (response.data.error) {
      transactionProxy.apiCall.error = response.data.error
      toast.warn('There was an error sending the receipt email')
    } else {
      transactionProxy.apiCall.loading = false
      toast.success('Receipt email sent successfully')
    }
  } catch (e) {
    if (e instanceof Error) {
      transactionProxy.apiCall.error = e.message
      toast.warn('There was an error sending the receipt email')
    }
  } finally {
    transactionProxy.apiCall.loading = false
  }
}

export async function executeResendEmailForTransactionFromLastTransaction (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>): Promise<void> {
  (e as React.FormEvent)?.preventDefault()

  virtualTerminalProxy.apiCall.loading = true
  virtualTerminalProxy.apiCall.error = null
  const { lastTransactionId } = snapshot(virtualTerminalProxy)
  try {
    const response = await buildAxiosInstance().post('/api/transactions/send_receipt_email',
      {
        transactionId: lastTransactionId
      }
    )
    if (response.data.error) {
      virtualTerminalProxy.apiCall.error = response.data.error
      toast.warn('There was an error sending the receipt email')
    } else {
      virtualTerminalProxy.apiCall.loading = false
      toast.success('Receipt email sent successfully')
    }
  } catch (e) {
    if (e instanceof Error) {
      virtualTerminalProxy.apiCall.error = e.message
      toast.warn('There was an error sending the receipt email')
    }
  } finally {
    virtualTerminalProxy.apiCall.loading = false
  }
}
